import { Checkbox } from "antd";
import React, { useState } from "react";

const data = [
  {
    title: "Landing Page Design",
  },
  {
    title: "Dashboard Builder",
  },
  {
    title: "Illustrations",
  },
  {
    title: "Mobile app Design",
    heading: "1 Fep, Due Tomorrow",
  },
  {
    title: "Create User Journey",
    heading: "3 Fep, Due 3 Days",
  },
  {
    title: "Create User Journ",
  },
  {
    title: "Landing Page Des",
  },
];

function Assignments() {
  const [checkedItems, setCheckedItems] = useState({});

  const onChange = (e, index) => {
    const newCheckedItems = { ...checkedItems, [index]: e.target.checked };
    setCheckedItems(newCheckedItems);
    console.log(newCheckedItems);
  };

  return (
    <div
      className="calendar_Style py-2 px-5 rounded-2xl"
      style={{
        backgroundColor: "#FFFFFF",
        boxShadow: "0px 4px 18px 0px #4B465C1A",
      }}
    >
      <h1 className="font-semibold">Assignments</h1>
      <div className="max-h-[150px] overflow-y-scroll">
        {data.map((item, index) => (
          <Checkbox
            key={index}
            className="w-full"
            onChange={(e) => onChange(e, index)}
            checked={checkedItems[index]}
          >
            <h1
              className={`font-semibold text-lg ml-5 ${
                (item.heading && "mt-5") ||
                (checkedItems[index] && "line-through text-MeduimGrey")
              }`}
            >
              {item.title}
            </h1>
            <p className="ml-5">{item.heading}</p>
          </Checkbox>
        ))}
      </div>
      <div className="p-1 bg-greenLight mt-3 text-center rounded-3xl text-greenDark font-semibold">
        <h1>3/5 Completed</h1>
      </div>
    </div>
  );
}

export default Assignments;
